var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaistemty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_2",
    "data-name": "katman 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 143.4 289.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    strokeWidth: ".56px",
    stroke: "#d41d20",
    strokeMiterlimit: 10,
    strokeDasharray: "0 0 1.6 1.6",
    x1: 0,
    y1: 114.28,
    x2: 143.4,
    y2: 114.28
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    strokeWidth: ".56px",
    stroke: "#d41d20",
    strokeMiterlimit: 10,
    strokeDasharray: "0 0 1.6 1.6",
    x1: 0,
    y1: 97.27,
    x2: 143.4,
    y2: 97.27
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    strokeWidth: ".25px",
    stroke: "#1e1e1c",
    x: 0.44,
    y: 0.13,
    width: 141.73,
    height: 289.13
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    strokeWidth: ".56px",
    stroke: "#d51bb1f",
    strokeMiterlimit: 10,
    strokeDasharray: "0 0 1.6 1.6",
    x1: 0,
    y1: 114.28,
    x2: 143.4,
    y2: 114.28
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    strokeWidth: ".56px",
    stroke: "#d51bb1f",
    strokeMiterlimit: 10,
    strokeDasharray: "0 0 1.6 1.6",
    x1: 0,
    y1: 97.27,
    x2: 143.4,
    y2: 97.27
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f5f2f1",
    strokeWidth: "0px",
    d: "M93.77,177.42l-.03-.07c-.4-.98-.98-1.85-1.71-2.61l-.25-.25-.04-.04,4.94-13.63,6.03,16.59h-8.94ZM75.44,171.24v-16.85s3.85,0,3.85,0c5.14,0,7.85,3.05,7.85,8.83,0,6.14-1.56,8.02-6.66,8.02h-5.04ZM50.3,177.45l6.02-16.59,6.02,16.58h-12.04ZM113.34,189.82l-13.89-36.65-.02-.07h-.21s-7.68,21.16-7.68,21.16c-1.74-1.54-4.2-2.5-7.29-2.86l-.94-.1.93-.12c5.1-.92,8.53-4.14,8.53-8.03,0-5.32-5.01-9.04-12.18-9.04h-15.11s0,.27,0,.27h4.34s0,27.06,0,27.06l-10.76-28.33h-.2s-13.29,36.63-13.29,36.63h-.07c-.45.06-.9.09-1.34.09h-10.71s20.96-35.72,20.96-35.72h-25.42s0,10.96,0,10.96h.27c.05-5.34,3.16-10.69,10.02-10.69h8.69s-21.01,35.73-21.01,35.73h27.76s0-10.5,0-10.5h-.27c-.04,4.65-2.67,9.07-8.4,10.07l-.18.03,4.37-12.01h12.25s4.35,12.1,4.35,12.1h-4.27s0,.27,0,.27h17.25s0-.27,0-.27h-4.36s0-18.31,0-18.31h5.04c5.13,0,8.07,2.29,8.07,6.28v3.25c0,.36.03.88.05,1.32h0s-2.71,7.46-2.71,7.46h-3.54s0,.26,0,.26h7.32s0-.26,0-.26h-3.5s2.47-6.77,2.47-6.77v.1s.07.61.07.61l.07.4c.41,2.5,1.37,4.34,2.84,5.46l.21.15c1.12.78,2.51,1.17,4.13,1.17,2.15,0,3.59-.54,4.77-1.8l-.16-.15c-1.09,1-2.01,1.42-3.15,1.42-1.96,0-2.98-2.37-2.98-4.71v-4.55c0-1.2-.18-2.31-.53-3.33l-.05-.14h8.97s4.36,12.13,4.36,12.13h-4.32s0,.26,0,.26h14.77s0-.26,0-.26h-4.32Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaistemty);
export default __webpack_public_path__ + "static/media/waistemty.97e24c1142cf3e6317cdb1d48f74d7fb.svg";
export { ForwardRef as ReactComponent };